import { Link } from "react-router-dom";
import CTAButton from "@/components/feature/CTAButton";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-onyx-50 flex flex-col items-center justify-center px-4">
      <div className="text-center">
        <div className="w-16 h-16 flex items-center justify-center bg-gunmetal-50 border border-onyx-400 mx-auto mb-6">
          <i className="ri-error-warning-line text-strike-500 text-3xl"></i>
        </div>
        <h1 className="font-heading text-5xl md:text-7xl font-bold text-white uppercase tracking-tight">
          404
        </h1>
        <p className="font-body text-white/40 text-sm md:text-base mt-3 mb-8 uppercase tracking-wider">
          Page not found
        </p>
        <CTAButton variant="primary" size="md" to="/">
          Return Home
        </CTAButton>
      </div>
    </div>
  );
}